// src/locationData.js

export const locationData = {
    National: {
      // No further levels, can skip if user chooses "National"
    },
    "Mexico Border": {
      states: {
        Arizona: {
          counties: {
            "Maricopa County": ["Phoenix", "Mesa", "Scottsdale"],
            "Pima County": ["Tucson", "Oro Valley", "Marana"]
          }
        },
        California: {
          counties: {
            "San Diego County": ["San Diego", "Chula Vista"],
            "Imperial County": ["El Centro", "Calexico"]
          }
        },
        "New Mexico": {
          counties: {
            "Dona Ana County": ["Las Cruces", "Anthony"],
            "Luna County": ["Deming"]
          }
        },
        Texas: {
          counties: {
            "El Paso County": ["El Paso", "Socorro"],
            "Hidalgo County": ["McAllen", "Edinburg"]
          }
        }
      }
    },
    "Canada Border": {
      states: {
        Alaska: {
          counties: {
            "Anchorage Borough": ["Anchorage", "Girdwood"],
            "Fairbanks North Star": ["Fairbanks", "North Pole"]
          }
        },
        Idaho: {
          counties: {
            "Boundary County": ["Bonners Ferry"],
            "Kootenai County": ["Coeur d'Alene", "Post Falls"]
          }
        },
        Washington: {
          counties: {
            "Whatcom County": ["Bellingham", "Blaine"],
            "Okanogan County": ["Omak", "Okanogan"]
          }
        }
      }
    }
  };
  